import { FC, useEffect, useLayoutEffect } from 'react';

import Helmet from '@/components/meta/Helmet';
import VelodromesTemplate from '@/components/templates/Velodrome';
import { useSetBreadcrumbContext } from '@/contexts/breadcrumb';
import { useLayoutContext } from '@/contexts/layout';

const VelodromesPage: FC = () => {
  const { setLayoutStyles } = useLayoutContext();
  const setBreadcrumbs = useSetBreadcrumbContext();

  useEffect(() => {
    setBreadcrumbs([
      {
        name: '競輪場一覧',
        to: '',
      },
    ]);
  }, []);

  useLayoutEffect(() => {
    setLayoutStyles();
  }, []);

  return (
    <>
      <Helmet
        meta={{
          title: '競輪場一覧',
          description: '競輪場一覧ページです。%s',
          keywords: '全国競輪,一覧,%s',
        }}
      />
      <VelodromesTemplate />
    </>
  );
};
export default VelodromesPage;
